import VueRouter from 'vue-router'
import Vue from 'vue'

import Home from '../components/Home/Home2.vue'
// import Mac from '../components/Mac/Mac'
// import iPad from "../components/iPad/iPad";
// import iPhone from "../components/iPhone/iPhone";
// import Music from "../components/Music/Music";
// import AirPodsDetails from "../components/Music/GoodsShow/AirPods Pro/AirPodsDetails";

import aboutUs from "../components/aboutUs/index";
import whatWeDo from "../components/whatWeDo/index";
import eventsNews from "../components/eventsNews/index";
import contact from "../components/contact/index";
import partners from "../components/partners/index";
import resouces from "../components/Resouces/index";

import navigation from "../components/page/navigation";
import cardNavigation from "../components/page/cardNavigation";
import search from "../components/page/search";
import detail from "../components/detail/index";
import personNotice from "../components/page/personNotice";
import personDetail from "../components/page/personDetail";
import leadership from "../components/page/leadership";
import nameAndLogo from "../components/page/nameAndLogo";
import organizationalStructure from "../components/page/organizationalStructure";
import summary from "../components/page/summary";
import strategic from "../components/page/strategic";
import messageBoard from "../components/page/messageBoard";



Vue.use(VueRouter)

var router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      component: Home,
    },
    // {
    //   path: '/mac',
    //   component: Mac,
    // },
    // {
    //   path: '/ipad',
    //   component: iPad,
    // },
    // {
    //   path: '/iphone',
    //   component: iPhone,
    // },
    // {
    //   path: '/music',
    //   component: Music,
    // },
    // {
    //   path: '/music/airpodspro',
    //   component: AirPodsDetails,
    // },

    {
      path: '/aboutUs',
      component: aboutUs,
    },
    {
      path: '/whatWeDo',
      component: whatWeDo,
    },
    {
      path: '/eventsNews',
      component: eventsNews,
    },
    {
      path: '/contact',
      component: contact,
    },
    {
      path: '/partners',
      component: partners,
    },
    //导航页
    {
      path: '/navigation',
      component: navigation,
    },
    //卡片导航页
    {
      path: '/cardNavigation',
      component: cardNavigation,
    },
    {
      path: '/resouces',
      component: resouces,
    },
    //详情页
    {
      path: '/detail',
      component: detail,
    },
    //查询页
    {
      path: '/search',
      component: search,
    },
    //通缉和失踪人员列表
    {
      path: '/personNotice',
      component: personNotice,
    },
    //通缉和失踪人员详情
    {
      path: '/personDetail',
      component: personDetail,
    },
    {
      path: '/leadership',
      component: leadership,
    },
    {
      path: '/nameAndLogo',
      component: nameAndLogo,
    },
    {
      path: '/organizationalStructure',
      component: organizationalStructure,
    },
    {
      path: '/summary',
      component: summary,
    }, {
      path: '/strategic',
      component: strategic,
    },
    {
      path: '/messageBoard',
      component: messageBoard,
    },
  ],
  mode: 'history'

})


export default router




// WEBPACK FOOTER //
// ./src/router/index.js